import { flowRight } from 'lodash';
import { connect } from 'react-redux';
import { MobileHeaderView } from './MobileHeaderView';
import { handleAutocompleteChange } from '../../../data/autocomplete';
import dropdownStateSelector from '../../../data/dropdown-state/dropdownStateSelector';
import {
    textBoxChange,
    closeDropdown,
    markOpenDropdown,
    openScanCard,
    recordScanCardAvailable,
} from '../../../data/dropdown-state/dropdownStateActions';
import insuranceTypeSelector from '../../../data/insurance-type/insuranceTypeSelector';
import { INSURANCE_TYPES } from '../../../../constants';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';

export function mapStateToProps(state, ownProps) {
    const currentState = dropdownStateSelector(state);
    const currentInsuranceType = insuranceTypeSelector(state);
    const { scanCardAttempted } = currentState;
    const shouldShowScanInsuranceCardButtonFlag =
        currentState.showScanInsuranceCardButton || !!(ownProps && ownProps.showScanInsuranceCardButton);
    const shouldShowScanInsuranceCardButton =
        shouldShowScanInsuranceCardButtonFlag && currentInsuranceType === INSURANCE_TYPES.HEALTH && !scanCardAttempted;

    return {
        tab: currentState.tab,
        typedValue: currentState.typedValue,
        isOpening: currentState.isOpening,
        shouldShowScanInsuranceCardButton,
    };
}

export const mapDispatchToProps = {
    closeDropdown,
    handleAutocompleteChange,
    markOpenDropdown,
    openScanCard,
    recordScanCardAvailable,
    textBoxChange,
};

export const MobileHeaderConnector = flowRight(
    withCustomMetrics({ component: 'InsurancePicker' }),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(MobileHeaderView);
